export default {
    pmusers_main_title: 'Platform Manager Users',
    pmusers_main_name: 'Name',
    pmusers_main_username: 'Username',
    pmusers_main_email: 'Email',
    pmusers_main_status: 'Status',
    pmusers_main_profile: 'Profiles',
    pmusers_main_created: 'Created',
    pmusers_main_updated: 'Updated',
    pmusers_main_add_user: 'Add User',
    pmusers_main_roles: 'Roles',
    pmusers_main_edit_user: 'Edit User',
    pmusers_main_delete_user: 'Delete User',
    pmusers_main_activate_user: 'Activate User',
    pmusers_main_deactivate_user: 'Deactivate user',
    pmusers_main_change_password: 'Change Password',
    pmusers_main_reset_password: 'Change Password',
    pmusers_main_last_name: 'Last Name',
    pmusers_main_force_logout: 'Force Logout',
    pmusers_main_logged_out: 'The user has been logged out',
    pmusers_main_not_logged_out: 'It was not possible to log out the user',
    pmusers_main_do_you_want_to_force_user_logout: 'Do you want to force user logout?',
    pmusers_main_logout: 'Logout',
    pmusers_main_registration_status: 'Registration Status',
    pmusers_main_registration_status_pending: 'Pending',
    pmusers_main_id: 'ID',
};